import { Stack, Flex, Spinner } from "@chakra-ui/react";
import React from "react"
import { EnergyConsumptionReport } from "../../../api/types";
import { EnergyReportBody } from "./EnergyReportBody";
import { EnergyReportTitlePage } from "./EnergyReportTitlePage";
import backgroundImg from '../../../../../assets/report/background.png'

type Props = {
    startDate: Date;
    endDate: Date;
    data: EnergyConsumptionReport,
    isDownloading: boolean
    displayData: any
}

export const EnergyConsumptionModal = ({ data, displayData, startDate, endDate, isDownloading }: Props) => {
    return (
        <Stack
            width="100%"
            height="100%"
            alignItems="center"
            id='pdf-container'
            backgroundImage={`url('${backgroundImg}')`}
            backgroundRepeat="no-repeat"
            backgroundSize="cover"
            backgroundPosition="left"
        >
            <Flex direction="column" justifyContent="center" alignItems="center" width="100%" height="100%">
                {isDownloading ? (
                    <Spinner
                        thickness='4px'
                        speed='0.65s'
                        emptyColor='gray.200'
                        color='blue.500'
                        size='xl'
                    />
                ) :
                    <>
                        <EnergyReportTitlePage data={displayData} startDate={startDate} endDate={endDate} locations={data} />
                        <EnergyReportBody data={displayData} locations={data} />
                    </>}
            </Flex>
        </Stack>
    )
}